import { GET_STUDENT_META_SKILLS } from '../../actions';
import { FAILURE, INVALIDATE, REQUEST, SUCCESS } from '../../actions/utils';
import { ICommonResponse, MetaSkill } from '../../api/types';
import { connectReducers } from '../../utils';
import { IReducers } from '..';
import genericReducers from '../genericReducer';

export type StudentMetaSkillsState = ICommonResponse<MetaSkill>;

const initialState: StudentMetaSkillsState = {
  content: [],
  loading: false,
};
const generic = genericReducers<StudentMetaSkillsState>();
const studentMetaSkills: IReducers<StudentMetaSkillsState> = {
  [GET_STUDENT_META_SKILLS[REQUEST]]: generic.get.request,
  [GET_STUDENT_META_SKILLS[SUCCESS]]: generic.get.success,
  [GET_STUDENT_META_SKILLS[FAILURE]]: generic.get.failure,
  [GET_STUDENT_META_SKILLS[INVALIDATE]]: generic.get.invalidate(initialState),
};

export default connectReducers(initialState, studentMetaSkills);
